Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "MultiOfferingsTitle2066011707",
  {"root":"MultiOfferingsTitle2066011707--root","title":"MultiOfferingsTitle2066011707--title"},
  "",
  2,
  "MultiOfferingsTitle2066011707"
);

